import { Link } from 'react-router-dom';
import { categories } from '@/mocks/software';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            全品类资源覆盖
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto">
            三大核心分类，涵盖办公软件、热门游戏、手机应用，满足您的所有需求
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-2xl p-8 text-center border border-background-200/70 hover:border-primary-300 transition-all duration-300"
            >
              <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl text-primary-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-xl font-semibold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors duration-200">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-5">
                {cat.desc}
              </p>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:gap-2 transition-all duration-200">
                浏览全部
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}